export const SidebarImage = () => {
  return (
    <img
      src="/logo_multiburo.svg"
      alt="Multiexpediente Multiburó"
      className="w-full h-auto max-w-[150px] md:max-w-[200px] lg:max-w-[200px]"
    />
  );
};
